import React, { useEffect, useState } from "react";
import {
	Container, Typography, Paper, Table, TableBody, TableCell, TableContainer,
	TableHead, TableRow, Button, TextField, Select, MenuItem, FormControl, Box, Pagination
} from "@mui/material";

import { AlertType } from 'mdui/page/MsgBox';
import { useUtil } from "mdui/page/UtilProvider";
import { post } from "mdui/api/HttpReq"; 
import JobListTable from "core/pages/tabs/batch/JobListTable";
import JobDetailTable from "core/pages/tabs/batch/JobDetailTable";
import ExecDtlTable from "core/pages/tabs/batch/ExecDtlTable";
import ExecJobDtlTable from "./tabs/batch/ExecJobDtlTable";
import RunJobModal from "core/pages/tabs/batch/RunJobModal";

export default function BatchJobs() {
	const [searchQuery, setSearchQuery] = useState("");
	const [showMainTable, setShowMainTable] = useState(true);
	const [filters, setFilters] = useState({ batchName: [], lastExecStts: [] });
	const [anchorEl, setAnchorEl] = useState(null);
	const [jobData, setJobData] = useState([]);
	const [page, setPage] = useState(1);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [openDialog, setOpenDialog] = useState(false);
	const [selectedProcess, setSelectedProcess] = useState(null);
	const [selectedJob, setSelectedJob] = useState(null);
	const [jobDetails, setJobDetails] = useState([]);
	const [showDetailsTable, setShowDetailsTable] = useState(false);
	const [pageDtl, setPageDtl] = useState(1);
	const [rowsDtlPerPage, setRowsDtlPerPage] = useState(10);
	const [searchQueryDtl, setSearchQueryDtl] = useState("");

	const [showExecDtlTable, setshowExecDtlTable] = useState(false);
	const [pageExec, setPageExec] = useState(1);
	const [rowsPerPageExec, setRowsPerPageExec] = useState(10);
	const [searchQueryExec, setSearchQueryExec] = useState("");
	const [jobExec, setJobExec] = useState([]);

	const [showJobExecDtlTable, setshowJobExecDtlTable] = useState(false);
	const [pageJobExec, setPageJobExec] = useState(1);
	const [rowsPerPageJobExec, setRowsPerPageJobExec] = useState(10);
	const [searchQueryJobExec, setSearchQueryJobExec] = useState("");
	const [jobExecDtl, setJobExecDtl] = useState([]);

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [jobParams, setJobParams] = useState({ batchName: '', param1: '' });
	const [loading, setLoading] = React.useState(false);


	const { openModel } = useUtil();

	const getData = (validate) => {
		console.log("getData");

		if (validate()) {
			setLoading(true); // Start loading

			async function load() {
				const param = {}; // can include filters/search fields
				try {
					const val = await post("viewJobNameDtls", "list", param);
					console.log("val", val);

					if (val && val.length > 0) {
						setJobData(val);
					} else {
						openModel({ msg: "no_records", type: AlertType.E });
					}
				} catch (error) {
					console.error("Failed to load job data", error);
					openModel({ msg: "load_error", type: AlertType.E });
				} finally {
					setLoading(false); // End loading only after async operation
				}
			}

			load(); // call the async function
		}
	};


	useEffect(() => {
		const validate = () => true;
		getData(validate);
	}, []);

	const openFilter = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const closeFilter = () => {
		setAnchorEl(null);
	};

	/*const filteredJobs = (jobData ?? []).filter((job) =>
		job.batchName?.toLowerCase().includes(searchQuery.toLowerCase())
	);

	const filteredJobsDtl = (jobDetails ?? []).filter((detail) =>
		detail.batchId?.toString().toLowerCase().includes(searchQueryDtl.toLowerCase())
	);

	const filteredJobsExec = (jobExec ?? []).filter((detailExec) =>
		detailExec.runNum?.toString().toLowerCase().includes(searchQueryExec.toLowerCase())
	);

	const filteredJobExec = jobExecDtl?.item &&
		jobExecDtl.item.runNum?.toString().toLowerCase().includes(searchQueryJobExec.toLowerCase())
		? [jobExecDtl.item]  // Wrap it in an array so you can `.map` over it later
		: [];*/
	// Always ensure we're filtering over arrays
	const filteredJobs = Array.isArray(jobData)
		? jobData.filter((job) =>
			job.batchName?.toLowerCase().includes(searchQuery.toLowerCase())
		)
		: [];

	// jobDetails
	const filteredJobsDtl = Array.isArray(jobDetails)
		? jobDetails.filter((detail) =>
			detail.batchId?.toString().toLowerCase().includes(searchQueryDtl.toLowerCase())
		)
		: [];

	// jobExec
	const filteredJobsExec = Array.isArray(jobExec)
		? jobExec.filter((detailExec) =>
			detailExec.runNum?.toString().toLowerCase().includes(searchQueryExec.toLowerCase())
		)
		: [];

	// jobExecDtl (single object case)
	const filteredJobExec =
		jobExecDtl?.item &&
			jobExecDtl.item.runNum?.toString().toLowerCase().includes(searchQueryJobExec.toLowerCase())
			? [jobExecDtl.item] // Wrap single object in an array for safe `.map`
			: [];



	const totalPages = Math.ceil(filteredJobs.length / rowsPerPage);

	const totalPagesDtl = Math.ceil(filteredJobsDtl.length / rowsDtlPerPage);

	const totalPagesExec = Math.ceil(filteredJobsExec.length / rowsPerPageExec);
	const totalPagesJobExec = Math.ceil(filteredJobExec.length / rowsPerPageJobExec);

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(1);
	};
	const handleChangeRowsDtlsPerPage = (event) => {
		setRowsDtlPerPage(parseInt(event.target.value, 10));
		setPageDtl(1);
	};

	const handleChangeRowsPerPageExec = (event) => {
		setRowsPerPageExec(parseInt(event.target.value, 10));
		setPageExec(1);
	};
	const handleChangeRowsPerPageJobExec = (event) => {
		setRowsPerPageJobExec(parseInt(event.target.value, 10));
		setPageJobExec(1);
	};

	const handleChangePage = (event, value) => {
		setPage(value);
	};

	const handleChangePageDtl = (event, value) => {
		setPageDtl(value);
	};

	const handleChangePageExec = (event, value) => {
		setPageExec(value);
	};

	const handleChangePageJobExec = (event, value) => {
		setPageJobExec(value);
	};
	const paginatedProcesses = filteredJobs.slice(
		(page - 1) * rowsPerPage,
		page * rowsPerPage
	);

	const paginatedProcessesDtl = filteredJobsDtl.slice(
		(pageDtl - 1) * rowsDtlPerPage,
		pageDtl * rowsDtlPerPage
	);

	const paginatedProcessesExec = filteredJobsExec.slice(
		(pageExec - 1) * rowsPerPageExec,
		pageExec * rowsPerPageExec
	);

	const paginatedProcessesJobExec = filteredJobExec.slice(
		(pageJobExec - 1) * rowsPerPageJobExec,
		pageJobExec * rowsPerPageJobExec
	);


	const handleJobClick = async (jobName, vdMaxCount) => {
		setLoading(true); // Start loading
		setSelectedJob(jobName);
		setShowDetailsTable(true);
		setShowMainTable(false);
		setshowExecDtlTable(false);

		try {
			const param = {
				jobName,
				vdMaxCount: vdMaxCount.toString(),
				vdPerPage: "20",
				vdPage: "1"
			};
			const res = await post("viewDtls", "list", param);
			console.log(res);
			setJobDetails(res || []);
		} catch (error) {
			console.error("Error loading job details", error);
			openModel({ msg: "load_error", type: AlertType.E });
		} finally {
			setLoading(false); // Stop loading
		}
	};


	const handleJobClickDtl = async (instanceId) => {
		setLoading(true);
		setShowDetailsTable(false);
		setShowMainTable(false);
		setshowExecDtlTable(true);

		try {
			const param = { instanceId: instanceId.toString() };
			const res = await post("viewExecDtl", "list", param);
			console.log(res);
			setJobExec(res || []);
		} catch (error) {
			console.error("Error loading execution details", error);
			openModel({ msg: "load_error", type: AlertType.E });
		} finally {
			setLoading(false);
		}
	};


	const handleJobClickExec = async (instanceId, execId) => {
		setLoading(true);
		setShowDetailsTable(false);
		setShowMainTable(false);
		setshowExecDtlTable(false);
		setshowJobExecDtlTable(true);

		try {
			const param = {
				instanceId: instanceId.toString(),
				execId: execId.toString()
			};
			const res = await post("viewJobExecDtl", "list", param);
			console.log(res);
			setJobExecDtl(res || []);
		} catch (error) {
			console.error("Error loading job execution details", error);
			openModel({ msg: "load_error", type: AlertType.E });
		} finally {
			setLoading(false);
		}
	};


	const handleBack = () => {
		setShowDetailsTable(false);
		setShowMainTable(true);
		setshowExecDtlTable(false);
		setSelectedJob(null);
		setJobDetails([]);
	};

	const handleBackExec = () => {
		setShowDetailsTable(true);
		setShowMainTable(false);
		setshowExecDtlTable(false);
		setshowJobExecDtlTable(false);
	};

	const handleBackJobExec = () => {
		setShowDetailsTable(false);
		setShowMainTable(false);
		setshowExecDtlTable(true);
		setshowJobExecDtlTable(false);
	};


	const handleOpenModal = (batchName, param1) => {
		setJobParams({ batchName, param1 });
		setIsModalOpen(true);
	};


	return (
		<Container sx={{ mt: "10px" }} maxWidth={false}>
			<Paper
				sx={{
					width: "90%",
					margin: "auto",
					boxShadow: 4,
					borderRadius: "12px",
					padding: "20px",
					backgroundColor: "#fff",
				}}
			>
				{showMainTable && (
					<JobListTable
						searchQuery={searchQuery}
						setSearchQuery={setSearchQuery}
						rowsPerPage={rowsPerPage}
						handleChangeRowsPerPage={handleChangeRowsPerPage}
						anchorEl={anchorEl}
						closeFilter={closeFilter}
						filters={filters}
						setFilters={setFilters}
						filteredJobs={filteredJobs}
						paginatedProcesses={paginatedProcesses}
						handleJobClick={handleJobClick}
						totalPages={totalPages}
						page={page}
						handleChangePage={handleChangePage}
						handleOpenModal={handleOpenModal}
						loading={loading}
					/>
				)}

				{showDetailsTable && (
					<JobDetailTable
						searchQueryDtl={searchQueryDtl}
						setSearchQueryDtl={setSearchQueryDtl}
						rowsDtlPerPage={rowsDtlPerPage}
						handleChangeRowsDtlsPerPage={handleChangeRowsDtlsPerPage}
						filteredJobsDtl={filteredJobsDtl}
						paginatedProcessesDtl={paginatedProcessesDtl}
						handleJobClickDtl={handleJobClickDtl}
						totalPagesDtl={totalPagesDtl}
						pageDtl={pageDtl}
						handleChangePageDtl={handleChangePageDtl}
						handleBack={handleBack}
						selectedJob={selectedJob}
						loading={loading}

					/>
				)}

				{showExecDtlTable && (
					<ExecDtlTable
						searchQueryExec={searchQueryExec}
						setSearchQueryExec={setSearchQueryExec}
						rowsPerPageExec={rowsPerPageExec}
						handleChangeRowsPerPageExec={handleChangeRowsPerPageExec}
						filteredJobsExec={filteredJobsExec}
						paginatedProcessesExec={paginatedProcessesExec}
						handleJobClickExec={handleJobClickExec}
						totalPagesExec={totalPagesExec}
						pageExec={pageExec}
						handleChangePageExec={handleChangePageExec}
						handleBackExec={handleBackExec}
						selectedJob={selectedJob}
						loading={loading}
					/>
				)}

				{showJobExecDtlTable && (
					<ExecJobDtlTable
						searchQueryJobExec={searchQueryJobExec}
						setSearchQueryJobExec={setSearchQueryJobExec}
						rowsPerPageJobExec={rowsPerPageJobExec}
						handleChangeRowsPerPageJobExec={handleChangeRowsPerPageJobExec}
						filteredJobExec={filteredJobExec}
						paginatedProcessesJobExec={paginatedProcessesJobExec}
						totalPagesJobExec={totalPagesJobExec}
						pageJobExec={pageJobExec}
						handleChangePageJobExec={handleChangePageJobExec}
						handleBackJobExec={handleBackJobExec}
						selectedJob={selectedJob}
						jobExecDtl={jobExecDtl}
					/>
				)}

				<RunJobModal
					open={isModalOpen}
					onClose={() => setIsModalOpen(false)}
					defaultParams={jobParams}
				/>
			</Paper>
		</Container>
	);


}
